var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DEFAULT_FETCH_STATUS = {
    fetchingInProgressSince: null,
    lastFailedFetch: null,
    lastSuccessfulFetch: null,
    didInvalidate: false,
    fetchPromise: undefined,
};
export function getInProgressFetchStatus(fetchStatus, fetchPromise) {
    var inProgressFetchStatus = __assign(__assign({}, fetchStatus), { fetchingInProgressSince: Date.now() });
    if (fetchPromise) {
        inProgressFetchStatus.fetchPromise = fetchPromise;
    }
    return inProgressFetchStatus;
}
export function getSuccessfulFetchStatus(fetchStatus) {
    return __assign(__assign({}, fetchStatus), { fetchingInProgressSince: null, didInvalidate: false, fetchPromise: undefined, lastSuccessfulFetch: Date.now() });
}
export function getFailedFetchStatus(fetchStatus) {
    return __assign(__assign({}, fetchStatus), { fetchingInProgressSince: null, lastFailedFetch: Date.now() });
}
